import apiService from '../apiService';

// 取得類型列表
export const getTypes = async (params = {}) => {
    const response = await apiService.GET('/api/admin/types', params);
    const payload = response?.data ?? response;
    if (Array.isArray(payload)) return payload;
    if (Array.isArray(payload?.data)) return payload.data;
    return [];
};

// 新增類型資料
export const createType = async (data) => {
    try {
        const response = await apiService.POST('api/admin/type', data);
        return response.data;
    } catch (error) {
        throw error;
    }
};

// 更新類型資料
export const updateType = async (typeId, data) => {
    try {
        const response = await apiService.PUT(`api/admin/type/${typeId}`, data);
        return response.data;
    } catch (error) {
        throw error;
    }
};

// 刪除類型資料
export const deleteType = async (typeId) => {
    try {
        const response = await apiService.DELETE(`api/admin/type/${typeId}`);
        return response.data;
    } catch (error) {
        throw error;
    }
};
